import virtualizationReducer from "./reducers";

export {
  fetchVMsListStart,
  fetchTaskStatusListStart,
  createVMTaskStart,
  controlVMStart,
  deleteVMStart,
  fetchVIRTRecoveryPointsStart,
  updateVMConfigurationsStart,
  rebuildVMStart,
  fetchVirtUserInfoStart,
  closeSSEConnection,
  logoutVirtInstances
} from "./operations";
export default virtualizationReducer;
